export type CompanyPaymentProfile = {
  entity: string;
  senderDisplayName: string;
  senderAddress: string;
  senderMobile: string;
  senderEmail: string;
  senderPayId: string | null;
  senderBsb: string;
  senderAccountNumber: string;
  senderAccountName: string;
};

export function getCompanyPaymentProfile(entity?: string | null): CompanyPaymentProfile {
  const normalized = String(entity || '').trim().toLowerCase();

  if (normalized === 'equilibrium engineering pty ltd') {
    return {
      entity: 'Equilibrium Engineering Pty Ltd',
      senderDisplayName: 'Equilibrium Engineering Pty. Ltd. (ACN 624618435)',
      senderAddress: '1/21 Barry Street, Bayswater VIC 3153',
      senderMobile: '0421 900 119',
      senderEmail: 'wdu@eqeng.com.au',
      senderPayId: 'WDU@eqeng.com.au',
      senderBsb: '063-109',
      senderAccountNumber: '1279-4847',
      senderAccountName: 'Equilibrium Engineering Pty Ltd (ACN: 624 618 435)',
    };
  }

  return {
    entity: 'Linfinity Engineering Pty Ltd',
    senderDisplayName: 'Linfinity Engineering Pty Ltd (ABN 64 427 178 431)',
    senderAddress: 'Suite 261, Tenancy 111, Camberwell Place, 793 Burke Road, Camberwell, VIC 3124',
    senderMobile: '0468 886 926',
    senderEmail: 'yl@linfinityeng.com',
    senderPayId: 'YL@linfinityeng.com',
    senderBsb: '013-479',
    senderAccountNumber: '4177-69018',
    senderAccountName: 'Linfinity Engineering Pty Ltd',
  };
}
